import React from "react"
import { ConfirmEmail as ConfirmEmailContainer } from "../../features/account"

const ConfirmEmail = () => <ConfirmEmailContainer redirectTo="/account/thank-you" />

export default ConfirmEmail
